/**
 * Pricing helpers — shared between server-side order creation and the live
 * price preview on the frontend so totals can never disagree.
 */

export interface PriceLineInput {
  productId: number;
  unitPrice: number;
  quantity?: number;
}

export interface PriceBreakdown {
  subtotal: number;
  shipping: number;
  total: number;
}

export const SHIPPING_FEE_KRW = 0; // free shipping for MVP

export function calculatePriceBreakdown(
  lines: PriceLineInput[],
): PriceBreakdown {
  const subtotal = lines.reduce(
    (acc, l) => acc + l.unitPrice * (l.quantity ?? 1),
    0,
  );
  const shipping = SHIPPING_FEE_KRW;
  const total = subtotal + shipping;
  return { subtotal, shipping, total };
}

export function formatKRW(amount: number): string {
  return `${amount.toLocaleString("ko-KR")}원`;
}
